import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OtpnotreceivedModalComponent } from '../otpnotreceived-modal/otpnotreceived-modal.component';
import { ResetPasswordModalComponent } from '../reset-password-modal/reset-password-modal.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-emailconfirmation',
  templateUrl: './emailconfirmation-modal.component.html',
  styleUrls: ['./emailconfirmation-modal.component.scss'],
})
export class EmailconfirmationModalComponent {
  // #region INPUT, OUTPUT, VIEWCHILD
  @Input() modalReference: any;

  @ViewChild('emailConfirmationModal')
  emailconfirmationTemplate!: TemplateRef<EmailconfirmationModalComponent>;
  @ViewChild('otpNotReceivedModal')
  otpNotRecievedComponent!: OtpnotreceivedModalComponent;
  @ViewChild('resetPasswordModal')
  resetPasswordComponent!: ResetPasswordModalComponent;
  // #endregion

  private modalService = inject(NgbModal);
  otpValue: string = '';
  email: string = '';
  resetCode: string = '';
  isDisableVerifyOTPBtn: boolean = false;
  isDisableResendBtn: boolean = false;

  formGroupOtp = new FormGroup({
    OTP: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(6),
    ]),
  });

  constructor(
    private authService: AuthService,
    private loaderService: LoaderService,
    private toastr: ToastrService

  ) {
    this.email = this.authService.getEmail();
    this.authService.userEmail$.subscribe((res) => {
      this.email = res;
    });
  }

  openModal(event: any, modal: TemplateRef<any>, windowClass: string = '') {
    if (
      windowClass != 'email-confirmation-Modal' &&
      windowClass != 'resendone'
    ) {
      this.fromGroupTouched(true);

      if (this.formGroupOtp.invalid) return;
      this.loaderService.setLoading(true);

      this.otpValue = this.formGroupOtp.get('OTP').value;
      this.isDisableVerifyOTPBtn = true;

      this.authService.verifyOTP(this.otpValue).subscribe((res: any) => {
        if (res && !res.error) {
          this.authService.userEmail$.next(this.email);
          this.resetCode = this.otpValue;
          this.isDisableVerifyOTPBtn = false;
          this.toastr.success("OTP verified successfully");

          this.commonModal(modal, windowClass);
        } else {
          this.isDisableVerifyOTPBtn = false;
        }
        this.loaderService.setLoading(false);
      });
    } else {
      this.isDisableResendBtn = false;
      this.otpNotRecievedComponent.isDisableResendBtn = false;
      this.commonModal(modal, windowClass);
    }
  }

  fromGroupTouched(isSubmitted: boolean = false) {
    if (this.formGroupOtp.touched || isSubmitted) {
      this.formGroupOtp.markAllAsTouched();
      this.formGroupOtp.updateValueAndValidity();
    }
  }

  formReset() {
    this.otpValue = '';
    this.formGroupOtp.reset();
    this.formGroupOtp.updateValueAndValidity();
  }

  commonModal(modal, windowClass) {
    this.modalReference.close();

    this.modalReference = this.modalService.open(modal, {
      windowClass: `project-modal ${windowClass}`,
      centered: true,
      backdropClass: 'primary-backdrop',
    });
  }

  onOtpChange(event: any) {
    this.otpValue = event;
  }

  onResendClick() {
    this.loaderService.setLoading(true);

    this.authService.getOTP(this.email).subscribe((res: string) => {
      if (!res) {
        this.authService.userEmail$.next(this.email);
        this.modalReference.close();
        this.toastr.success("OTP resent successfully");
        this.openModal('', this.emailconfirmationTemplate, 'resendone');
      }
      this.isDisableResendBtn = false;
      this.loaderService.setLoading(false);
    });
  }

  enterKeyPress(event) {
    /** Note - keycode 13 mining Enter key */
    if (event.keyCode === 13) {
      this.openModal('', this.resetPasswordComponent.resetPasswordTemplate);
    }
  }
}
